import { Link, Outlet } from 'react-router-dom';
import { AuthHeroPanel } from '@/components/auth/AuthHeroPanel';
import { LanguageSwitcher } from '@/components/common/LanguageSwitcher';
import { SiteLogo } from '@/components/common/SiteLogo';
import { useI18n } from '@/hooks/useI18n';
import { useSiteName } from '@/hooks/useSiteName';

export default function AuthLayout() {
  const { t } = useI18n();
  const siteName = useSiteName();

  return (
    <div className="min-h-dvh bg-gradient-to-br from-muted/70 via-background to-primary/5 px-0 py-0 sm:px-5 sm:py-8 lg:px-8">
      <main className="mx-auto flex min-h-dvh w-full max-w-6xl items-center sm:min-h-[calc(100dvh-4rem)]">
        <div className="grid w-full overflow-hidden border-border/60 bg-card shadow-2xl shadow-primary/10 sm:rounded-3xl sm:border lg:grid-cols-[0.9fr_1.1fr]">
          <AuthHeroPanel />

          <section className="flex min-h-dvh flex-col p-5 sm:min-h-0 sm:p-8 lg:p-12">
            <div className="mb-8 flex items-center justify-between lg:justify-end">
              <Link
                to="/"
                className="text-xl font-bold text-primary lg:hidden"
                aria-label={t('auth.backHome', { siteName })}
              >
                <SiteLogo imageClassName="h-9" />
              </Link>
              <LanguageSwitcher className="h-10 rounded-full border bg-background px-3" />
            </div>

            <div className="flex flex-1 items-center">
              <Outlet />
            </div>

            <p className="mt-8 text-center text-xs text-muted-foreground lg:hidden">
              {t('auth.copyright', {
                year: String(new Date().getFullYear()),
                siteName,
              })}
            </p>
          </section>
        </div>
      </main>
    </div>
  );
}
